import { Action, createReducer, on } from '@ngrx/store';
import { IUserDeceasedUpdateRequest, IUserDeceasedUpdateResponse } from '../models/deceased.model';
import { IGenericError, ErrorResponse } from 'src/app/core/models/generic-models';
import { updateUserDeceasedRequest, updateUserDeceasedResponse, updateUserDeceasedFailure } from '../actions/deceased.actions';

export const updateDeceasedReducerFeatureKey = 'updateDeceasedReducer';

export interface UpdateDeceasedState {
  updateUserDeceasedRequest: IUserDeceasedUpdateRequest;
  updateUserDeceasedResponse: IUserDeceasedUpdateResponse;
  updateUserDeceasedFailure: IGenericError<ErrorResponse>;
}

export const initialState: UpdateDeceasedState = {
  updateUserDeceasedRequest: undefined,
  updateUserDeceasedResponse: undefined,
  updateUserDeceasedFailure: undefined
};

export const reducer = createReducer(
  initialState,

  on(updateUserDeceasedRequest, (state, action) => ({
    ...state,
    updateUserDeceasedRequest: action.request
  })),
  on(updateUserDeceasedResponse, (state, action) => ({
    ...state,
    updateUserDeceasedResponse: action.response
  })),
  on(updateUserDeceasedFailure, (state, action) => ({
    ...state,
    updateUserDeceasedFailure: action.error
  }))
);

export const updateAUserDeceasedRequest = (state: UpdateDeceasedState) => state.updateUserDeceasedRequest;
export const updateAUserDeceasedResponse = (state: UpdateDeceasedState) => state.updateUserDeceasedResponse;
export const updateAUserDeceasedFailure = (state: UpdateDeceasedState) => state.updateUserDeceasedFailure;
